<template>
	<div>
		<h1>Veículos Volkswagen</h1>
		<p class="vw-head-normal">Selecione seu veículo na lista abaixo para encontrar suas peças.</p>

		<!-- Algolia -->
		<ais-instant-search :search-client="searchClient" :index-name="algoliaIndex" :stalled-search-delay="1000">
			<ais-configure :hitsPerPage="99"></ais-configure>

			<!-- Informações carro -->
			<div class="carro" v-if="veiculoSelecionado">
				<div class="carro__img">
					<img v-if="veiculoSelecionado.imagem" :src="`/custom/loja/assets/media/veiculos/${veiculoSelecionado.imagem}`" />
					<img class="no-car" v-else :src="`/custom/loja/assets/media/veiculos/sem_foto.png`" />
				</div>
				<div class="carro__content">
					<h2>{{ veiculoSelecionado.veiculo }}</h2>
					<div class="carro__ano">{{ veiculoSelecionado.ano_de }}-{{ veiculoSelecionado.ano_ate }}</div>
					<div class="carro__extra">
						Para facilitar sua busca por peças selecione o ano de seu <b>{{ veiculoSelecionado.veiculo }}</b
						>.
					</div>
					<div class="carro__select">
						<SelectVW :values="veiculoSelecionado.list_anos" :label="'Selecione o ano'" v-model="anoVeiculo" />
					</div>
					<button class="btn__primary" @click="mountRoute()">Buscar peças para este modelo</button>
				</div>
			</div>

			<div class="veiculoencontrado">
				<ais-state-results>
					<template slot-scope="{ status }">
						<Loader v-show="status === 'loading' || status === 'stalled'" />

						<ais-hits class="lista-veiculos">
							<template slot-scope="{ items }">
								<div v-for="(c, $c) in searchModel(items)" :key="$c">
									<div v-if="c.veiculos.length > 0">
										<h2>{{ c.label }}</h2>
										<div class="wrapper-veiculos">
											<div class="veiculo__box" v-for="v in c.veiculos" :key="v.objectID" @click="selecionarVeiculo(v)">
												<div class="veiculo__img">
													<img v-if="v.imagem" :src="`/custom/loja/assets/media/veiculos/${v.imagem}`" />
													<img class="no-car" v-else :src="`/custom/loja/assets/media/veiculos/sem_foto.png`" />
												</div>
												<div class="veiculo__nome">{{ v.veiculo }}</div>
												<div class="veiculo__anos">{{ v.ano_de }}/{{ v.ano_ate }}</div>
											</div>
										</div>
									</div>
								</div>
							</template>
						</ais-hits>
					</template>
				</ais-state-results>
			</div>
		</ais-instant-search>
	</div>
</template>
<script>
import SelectVW from "@/components/Common/SelectVW"
import Loader from "@/components/Common/Loader"
import { AisInstantSearch, AisStateResults, AisConfigure, AisHits } from "vue-instantsearch"
import algoliasearch from "algoliasearch/lite"
import { history } from "instantsearch.js/es/lib/routers"
import { singleIndex } from "instantsearch.js/es/lib/stateMappings"
export default {
	components: {
		AisInstantSearch,
		AisConfigure,
		AisStateResults,
		AisHits,
		Loader,
		SelectVW,
	},
	computed: {
		algoliaIndex() {
			return "home_aplicacoes"
		},
	},
	methods: {
		searchModel(arrayModelos) {
			if (this.localQuery !== "") {
				let search = (list, text) => list.filter((i) => i.veiculo.toLowerCase().includes(text.toLowerCase()))
				let result = search(arrayModelos, this.localQuery)
				return this.categorizacao(result)
			}
			return this.categorizacao(arrayModelos)
		},
		mountRoute() {
			let veiculo = this.veiculoSelecionado.veiculo_base.toLowerCase()
			let ano = this.anoVeiculo
			this.$router.push({ path: "lista/", query: { veiculo: `${veiculo}`, ano: `${ano}` } })
		},
		selecionarVeiculo(veiculo) {
			this.veiculoSelecionado = veiculo
			const scrollArea = document.querySelector("html")
			scrollArea.scrollIntoView({ block: "start", behavior: "smooth" })
		},
		categorizacao(hits) {
			let carrosPorCategoria = [
				{
					categoria: "atuais",
					label: "Veículos Volkswagen Atuais",
					veiculos: [],
				},
				{
					categoria: "descontinuados",
					label: "Veículos Volkswagen Descontinuados",
					veiculos: [],
				},
				{
					categoria: "clássicos",
					label: "Veículos Volkswagen Clássicos",
					veiculos: [],
				},
			]
			for (const iterator of hits) {
				if (iterator.categoria === "atuais") {
					let cat = carrosPorCategoria.find((s) => s.categoria === "atuais")
					cat.veiculos.push(iterator)
				}
				if (iterator.categoria === "descontinuados") {
					let cat = carrosPorCategoria.find((s) => s.categoria === "descontinuados")
					cat.veiculos.push(iterator)
				}
				if (iterator.categoria === "clássicos") {
					let cat = carrosPorCategoria.find((s) => s.categoria === "clássicos")
					cat.veiculos.push(iterator)
				}
			}
			return carrosPorCategoria
		},
	},
	data() {
		return {
			searchClient: algoliasearch(this.$epecaHubB2c.configJson.ALGOLIA_APPLICATION_ID, this.$epecaHubB2c.configJson.ALGOLIA_API_KEY_READ_ONLY),
			routing: {
				router: history(),
				stateMapping: singleIndex(this.algoliaIndex),
			},
			veiculoSelecionado: null,
			anoVeiculo: null,
			localQuery: "",
		}
	},
}
</script>

<style scoped lang="scss">
.veiculos {
	padding: 0px 16px 16px 16px;
	h1 {
		font-size: 24px;
		line-height: 29px;
		align-items: center;
		color: #001e50;
		text-align: center;
		display: block;
		@media (min-width: 768px) {
			font-size: 32px;
			line-height: 39px;
		}
	}
	p {
		font-size: 16px;
		line-height: 20px;
		color: #3c484d;
		padding: 0;
		margin: 16px 0;
		display: block;
		@media (min-width: 768px) {
			font-size: 24px;
			line-height: 29px;
			text-align: center;
		}
	}
}
.buscaveiculo {
	background-color: #fff;
	padding: 16px;
	box-shadow: 0px 8px 16px rgb(0 0 0 / 30%);
	margin: 32px 0;
}
.buscaveiculo__box {
	display: flex;
	border-bottom: 2px solid #001e50;
	align-items: center;
	padding-bottom: 16px;
	input {
		width: 100%;
		font-size: 16px;
		line-height: 20px;
		display: flex;
		align-items: center;
		color: #6a767d;
	}
}
.lista-veiculos {
	display: flex;
	flex-direction: column;
	gap: 64px;
}
h2 {
	font-size: 28px;
	line-height: 32px;
	color: #001e50;
	margin-bottom: 32px;
}
.wrapper-veiculos {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr;
	gap: 16px;
}
.veiculo__box {
	display: flex;
	flex-direction: column;
	align-items: center;
}
.veiculo__nome {
	font-size: 24px;
	line-height: 29px;
	display: flex;
	align-items: center;
	text-align: center;
	color: #3c484d;
	margin-bottom: 8px;
	font-family: "VWHead-Bold", sans-serif;
}
.veiculo__img {
	cursor: pointer;
	&:hover {
		outline: 2px solid #001e50;
	}
	img {
		height: 160.31px;
	}
}
.carro {
	display: grid;
	grid-template-columns: 705px 1fr;
	gap: 16px;
	margin-bottom: 32px;
	&__content {
		h2 {
			margin-bottom: 16px;
		}
	}
	&__ano {
		font-weight: 400;
		font-size: 24px;
		line-height: 29px;
		display: flex;
		align-items: center;
		color: #3c484d;
		font-family: var(--head-regular);
		margin-bottom: 16px;
	}
	&__desc {
		font-weight: 300;
		font-size: 16px;
		line-height: 20px;
		font-family: var(--head-regular);
		color: #6a767d;
		margin-bottom: 32px;
	}
	&__select {
		margin-bottom: 32px;
	}
	&__extra {
		font-family: var(--head-regular);
		font-style: normal;
		font-weight: 400;
		font-size: 24px;
		line-height: 29px;
		color: #6a767d;
		margin-bottom: 24px;
		b {
			color: #3c484d;
			font-family: var(--head-bold);
		}
	}
}
.btn__primary {
	background: #001e50;
	color: #fff;
	border-radius: 100px;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	padding: 10px 20px;
	gap: 8px;
	width: 100%;
	font-size: 16px;
	line-height: 20px;
	font-family: var(--head-regular);
	&:disabled {
		opacity: 0.4;
	}
	@media (min-width: 768px) {
		padding: 16px 24px;
	}
}
@media (max-width: 767px) {
	.carro {
		display: flex;
		flex-direction: column;
		margin-bottom: 32px;
		&__ano {
			justify-content: center;
			font-size: 18px;
			line-height: 22px;
		}
		&__content {
			h2 {
				text-align: center;
				font-size: 20px;
				line-height: 24px;
			}
		}
		&__extra {
			font-size: 16px;
			line-height: 20px;
		}
	}
	.buscaveiculo {
		margin-bottom: 16px;
	}
	.wrapper-veiculos {
		grid-template-columns: 1fr 1fr;
	}
	.veiculo__img img {
		height: auto;
	}
	.veiculo__nome {
		font-size: 18px;
		line-height: 22px;
	}
	.lista-veiculos {
		h2 {
			font-size: 20px;
			line-height: 24px;
		}
	}
}
</style>
